import { render, staticRenderFns } from "./ActiveProposals.vue?vue&type=template&id=6144e306&scoped=true&"
import script from "./ActiveProposals.vue?vue&type=script&lang=js&"
export * from "./ActiveProposals.vue?vue&type=script&lang=js&"
import style0 from "./ActiveProposals.vue?vue&type=style&index=0&id=6144e306&prod&lang=css&"
import style1 from "./ActiveProposals.vue?vue&type=style&index=1&id=6144e306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144e306",
  null
  
)

export default component.exports